import type { CatalogManifestFile, CatalogOperatorDownloadInput } from "./catalogTypes";
import { normalizeCatalogFileRow } from "./catalogFileLookup";
import { pickMainSasFromCatalogRow } from "./pickMainSas";

function asRecord(v: unknown): Record<string, unknown> | null {
  return v && typeof v === "object" && !Array.isArray(v) ? (v as Record<string, unknown>) : null;
}

function manifestFilesFromRow(row: Record<string, unknown>): CatalogManifestFile[] {
  const rawFiles = row.files ?? row.Files;
  const fileRows = Array.isArray(rawFiles) ? rawFiles : [];
  const out: CatalogManifestFile[] = [];
  for (const item of fileRows) {
    const entry = normalizeCatalogFileRow(item);
    if (entry) {
      out.push({ id: entry.id, sas: entry.sas, ext: entry.ext });
    }
  }
  return out;
}

function stakeholderMapFromRow(row: Record<string, unknown>): Record<string, string> {
  const m = row.allStakeholderSas;
  const rec = asRecord(m);
  if (!rec) return {};
  const out: Record<string, string> = {};
  for (const [k, v] of Object.entries(rec)) {
    out[k] = typeof v === "string" ? v : "";
  }
  return out;
}

/**
 * Map a loose API/catalog row into download input. Throws if required ids are missing.
 */
export function catalogRowToDownloadInput(row: Record<string, unknown>): CatalogOperatorDownloadInput {
  const operatorId =
    typeof row.operatorId === "string" && row.operatorId.trim()
      ? row.operatorId.trim()
      : typeof row.id === "string" && row.id.trim()
        ? row.id.trim()
        : "";
  if (!operatorId) {
    throw new Error("Catalog row missing operatorId");
  }
  const name = typeof row.name === "string" ? row.name : "";
  const currentVersion = typeof row.currentVersion === "string" ? row.currentVersion : "";
  if (!currentVersion) {
    throw new Error(`Catalog row missing currentVersion for operator ${operatorId}`);
  }
  const logo =
    typeof row.logoImageSasUrl === "string" && row.logoImageSasUrl.trim()
      ? row.logoImageSasUrl.trim()
      : null;

  return {
    operatorId,
    name,
    currentVersion,
    mainSasUrl: pickMainSasFromCatalogRow(row),
    manifestFiles: manifestFilesFromRow(row),
    stakeholderSasByCode: stakeholderMapFromRow(row),
    logoImageSasUrl: logo,
  };
}
